import { graphql, useStaticQuery } from 'gatsby';

// Better to have a list of common queries in one place than to have the same query repeated in multiple components.
// This also allows us to use the query in providers and pass the data down via context, which is better for performance than having multiple components all run the same query with useStaticQuery.
export const useCustomCardSliderQuery = () => {
	const data = useStaticQuery(graphql`
{
	allSmartTagsCustomCardSlider(
		filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
	) {
		edges {
			node {
				id
				title
				description
				cardType
				cards {
					title
					image
					description
					link
					linkText
					videoEmbed
				}
				background
				backgroundImage
				backgroundProps
				flush
				padding
				Audience {
				  ...AudienceRelationshipDetailsFragment
				}
			}
		}
	}
}
`);
	return { data };
};